import React from "react";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";
import { PROCESS_STEPS } from "../data/site";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Our Process", path: "/our-process" }];

const Process = () => (
  <>
    <Seo
      title="Our Custom Home Building Process | Build Highland Homes"
      description="See how the custom home building process works with Build Highland Homes — from the first conversation and property evaluation through design, permitting, construction, and completion."
      path="/our-process"
      keywords="custom home building process, how custom home building works, custom home construction stages"
      breadcrumbs={breadcrumbs}
    />
    <PageHero overline="How We Build" title="The Custom Home Building Process" subtitle="A clear, stage-by-stage journey from your first idea to the keys of your finished custom home — with honest communication throughout." image={IMAGES.realHomeConstruction} />

    <Section className="bg-[#0b0b0b]">
      <div className="max-w-3xl mx-auto space-y-6">
        {PROCESS_STEPS.map((s) => (
          <div key={s.n} className="flex gap-6 items-start bg-[#141414] border border-[#c9a24b]/15 p-6">
            <div className="shrink-0 w-14 h-14 flex items-center justify-center rounded-full border border-[#c9a24b]/40"><span className="font-serif-display text-xl text-[#e3c77a]">{s.n}</span></div>
            <div>
              <h2 className="font-serif-display text-2xl text-[#f3ede0] mb-1">{s.title}</h2>
              <p className="text-[#a39d90] leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>

    <CTASection />
  </>
);

export default Process;
